import { ButtonHTMLAttributes, ReactNode } from 'react';
import { clsx } from 'clsx';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
}

export default function Button({ 
  children, 
  variant = 'primary', 
  size = 'md',
  className,
  ...props 
}: ButtonProps) {
  const baseStyles = 'font-medium transition-all duration-300 rounded-sm';
  
  const variants = {
    primary: 'bg-forest-900 text-white hover:bg-forest-800 hover:scale-[1.02]',
    secondary: 'bg-jungle-600 text-white hover:bg-jungle-700 hover:scale-[1.02]',
    outline: 'border-2 border-forest-900 text-forest-900 hover:bg-forest-900 hover:text-white'
  };
  
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg'
  };

  return (
    <button 
      className={clsx(baseStyles, variants[variant], sizes[size], className)}
      {...props}
    >
      {children}
    </button>
  );
}
